import(/* webpackMode: "eager" */ "/home/runner/_work/booking-calcom-setup/booking-calcom-setup/calcom/apps/web/app/global-error.tsx");
